import { render, staticRenderFns } from "./product-finish-carousel.vue?vue&type=template&id=d595ba80&scoped=true&"
import script from "./product-finish-carousel.vue?vue&type=script&lang=js&"
export * from "./product-finish-carousel.vue?vue&type=script&lang=js&"
import style0 from "./product-finish-carousel.vue?vue&type=style&index=0&id=d595ba80&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d595ba80",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/reddeleon/Sites/watermark-designs/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d595ba80')) {
      api.createRecord('d595ba80', component.options)
    } else {
      api.reload('d595ba80', component.options)
    }
    module.hot.accept("./product-finish-carousel.vue?vue&type=template&id=d595ba80&scoped=true&", function () {
      api.rerender('d595ba80', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/js/product-finishes-slider/components/product-finish-carousel.vue"
export default component.exports